import { ANEXO_MENSAGENS_PADRAO } from "./anexo-dialog.constants";
import type { AnexoDialogMensagens } from "./types-anexo-dialog";

export interface AnexoRegras {
  identificacaoMax: number;
  extensoes: readonly string[];
  tamanhoMaxMb: number;
  mensagens: AnexoDialogMensagens;
}

export type AnexoCampo = "identificacao" | "arquivo";

export function resolverMensagens(
  parcial: Partial<AnexoDialogMensagens> | undefined,
): AnexoDialogMensagens {
  return { ...ANEXO_MENSAGENS_PADRAO, ...parcial };
}

function extensaoDe(nome: string): string {
  const ponto = nome.lastIndexOf(".");
  return ponto === -1 ? "" : nome.slice(ponto + 1).toLowerCase();
}

/** `4,8 MB` / `512 KB`: megabytes a partir de 1 MB, quilobytes abaixo. */
export function formatarTamanhoAnexo(bytes: number): string {
  const mega = 1024 * 1024;
  if (bytes >= mega) {
    return `${(bytes / mega).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} MB`;
  }
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

export function validarIdentificacaoAnexo(value: unknown, regras: AnexoRegras): string | null {
  const texto = typeof value === "string" ? value.trim() : "";
  if (!texto) return regras.mensagens.identificacaoObrigatoria;
  return texto.length > regras.identificacaoMax
    ? regras.mensagens.identificacaoMax(regras.identificacaoMax)
    : null;
}

/** Erro do arquivo escolhido (vazio, extensão ou tamanho), ou `null` quando válido. */
export function validarArquivoAnexo(value: unknown, regras: AnexoRegras): string | null {
  if (!(value instanceof File)) return regras.mensagens.arquivoObrigatorio;
  if (!regras.extensoes.includes(extensaoDe(value.name))) return regras.mensagens.formatoInvalido;
  if (value.size > regras.tamanhoMaxMb * 1024 * 1024) {
    return regras.mensagens.tamanhoInvalido(
      value.name,
      formatarTamanhoAnexo(value.size),
      regras.tamanhoMaxMb,
    );
  }
  return null;
}
